export const TRANSITION_PROPERTY_TIMEOUT = 200;
export const COUNT_SELECTED_COL_FILTERS = 5;
export const FIRST_TIME_BADGE_DISABLED = { count: 0 };
export const COL_FILTER_HEADER_USER = 'User';
export const COL_FILTER_HEADER_ROLE = 'Role';
export const COL_FILTER_HEADER_ACCOUNT = 'Account';
export const COL_FILTER_HEADER_ENTITLEMENT = 'Entitlement';
export const COL_FILTER_HEADER_CHILD_ENTITLEMENT = 'Child Entitlement';

export const ORDER_OF_COL_FILTERS = [
  COL_FILTER_HEADER_USER,
  COL_FILTER_HEADER_ACCOUNT,
  COL_FILTER_HEADER_ENTITLEMENT,
  COL_FILTER_HEADER_ROLE,
  COL_FILTER_HEADER_CHILD_ENTITLEMENT,
];

export const FIXED_COL_FOR_USER = 'User_DISPLAYNAME';
export const FIXED_COL_FOR_ROLE = 'Role_DISPLAYNAME';
export const FIXED_COL_FOR_ACCOUNT = 'Account_DISPLAYNAME';
export const FIXED_COL_FOR_ENTITLEMENT = 'Ent_DISPLAYNAME';
export const FIXED_COL_FOR_CHILD_ENTITLEMENT = 'ChildEnt_DISPLAYNAME';

export const EO_FIXED_COL_FOR_ACCOUNT = 'DEFAULTACCOUNTNAME';
export const EO_FIXED_COL_FOR_ENTITLEMENT = 'DEFAULTENTITLEMENTNAME';
export const EO_FIXED_COL_FOR_CHILD_ENTITLEMENT = 'DEFAULTENTITLEMENT2NAME';

export const FIXED_COL_FILTERS = [
  `${COL_FILTER_HEADER_USER.toUpperCase()}-${FIXED_COL_FOR_USER}`,
  `${COL_FILTER_HEADER_ACCOUNT.toUpperCase()}-${FIXED_COL_FOR_ACCOUNT}`,
  `${COL_FILTER_HEADER_ENTITLEMENT.toUpperCase()}-${FIXED_COL_FOR_ENTITLEMENT}`,
  `${COL_FILTER_HEADER_ROLE.toUpperCase()}-${FIXED_COL_FOR_ROLE}`,
  `${COL_FILTER_HEADER_CHILD_ENTITLEMENT.toUpperCase()}-${EO_FIXED_COL_FOR_CHILD_ENTITLEMENT}`,
];

export const PRIORITY_COLUMNS = [
  `${COL_FILTER_HEADER_ACCOUNT.toUpperCase()}-ENDPOINT`,
  `${COL_FILTER_HEADER_ENTITLEMENT.toUpperCase()}-ENTITLEMENTTYPE`,
  `${COL_FILTER_HEADER_ROLE.toUpperCase()}-Role_ROLETYPE`,
];

export {
  ACC_CERT_ENTITLEMENT_VALUEKEY,
  ENT_CERT_ENTITLEMENT_VALUEKEY,
  OBJECTS_TO_BE_INCLUDED_ACCOUNTS,
  OBJECTS_TO_BE_INCLUDED_ENTITLEMENTS,
  OBJECTS_TO_BE_INCLUDED_ROLES,
  OBJECTS_TO_BE_INCLUDED_USERS,
  RLE_CERT_ENTITLEMENT_VALUEKEY,
  USR_CERT_ENTITLEMENT_VALUEKEY,
} from '../RowsFilter';
